import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import accounts from "./accounts";
import announcements from "./announcements";
import events from "./events";
import fdroid from "./fdroid";
import files from "./files";
import groups from "./groups";
import licenses from "./licenses";
import oauthClients from "./oauthClients";
import products from "./products";
import roles from "./roles";
import settings from "./settings";
import { adminTagTypes } from "./tags";
import workspaces from "./workspaces";

export const adminApi = createApi({
    reducerPath: "adminApi",
    tagTypes: adminTagTypes,
    keepUnusedDataFor,
    // Admin data is changed by other admins and by backend jobs, so this app's own tag invalidation never
    // covers it. Without a refetch on mount, a page re-opened within the cache lifetime shows stale rows.
    refetchOnMountOrArgChange: true,
    baseQuery,
    endpoints: (builder) => ({
        ...accounts(builder),
        ...announcements(builder),
        ...events(builder),
        ...fdroid(builder),
        ...files(builder),
        ...groups(builder),
        ...licenses(builder),
        ...oauthClients(builder),
        ...products(builder),
        ...roles(builder),
        ...settings(builder),
        ...workspaces(builder),
    }),
});

export const {
    useAssignRoleMutation,
    useAttachLicenseMutation,
    useCreateOauthClientMutation,
    useDeleteAccountMutation,
    useDeleteAdminGroupMutation,
    useDeleteLicensesMutation,
    useDeleteOauthClientMutation,
    useDetachLicenseMutation,
    useExportAnnouncementEmailsMutation,
    useGetAccountsQuery,
    useGetAdminFilesQuery,
    useGetAllEventsQuery,
    useGetAllProductsQuery,
    useGetCertificateQuery,
    useGetEmailConfigQuery,
    useGetFdroidReposQuery,
    useGetLicenseStatisticsQuery,
    useGetOauthClientQuery,
    useGetOauthClientsQuery,
    useGetRolesQuery,
    useGetSubscribersQuery,
    useGetAllWorkspacesQuery,
    useGrantLicensesMutation,
    useInspectLicenseMutation,
    useLazyGetAdminGroupsQuery,
    useMoveGroupLicensesMutation,
    useMoveLicenseMutation,
    useRemoveRoleMutation,
    useReviveLicenseMutation,
    useRevokeGroupLicensesMutation,
    useRevokeLicenseMutation,
    useSendTestEmailMutation,
    useUnsubscribeSubscribersMutation,
    useUpdateCertificateMutation,
    useUpdateEmailConfigMutation,
    useUpdateOauthClientMutation,
} = adminApi;
